import SiteHeader from "@/components/feature/SiteHeader";
import Footer from "@/pages/home/components/Footer";
import HireFeatures from "./components/HireFeatures";
import PostJobPanel from "./components/PostJobPanel";

const EMPLOYER_STATS = [
  { value: "8 min", label: "Avg. time to first match" },
  { value: "4.8★", label: "Avg. worker rating" },
  { value: "94%", label: "Jobs filled same day" },
  { value: "3,200+", label: "Active employers" },
];

export default function HirePage() {
  return (
    <div className="min-h-screen bg-[#fafafa]">
      <SiteHeader />

      {/* Hero */}
      <section
        className="pt-28 pb-0 bg-white border-b border-gray-100 relative overflow-hidden"
        style={{ minHeight: 480 }}
      >
        <div className="max-w-7xl mx-auto px-4 md:px-8 flex flex-col lg:flex-row gap-12 items-start">
          {/* Left */}
          <div className="flex-1 pb-14 pt-2">
            <span className="inline-block text-xs font-bold uppercase tracking-widest text-emerald-600 bg-emerald-50 px-3.5 py-1.5 rounded-full mb-4">
              For Employers
            </span>
            <h1 className="text-4xl md:text-5xl font-extrabold text-gray-900 mb-4 leading-tight">
              Hire Skilled Workers.<br />
              <span className="text-emerald-500">Instantly.</span>
            </h1>
            <p className="text-gray-500 text-lg mb-8 max-w-lg">
              Post a job in 60 seconds and get matched with qualified, vetted workers in your area — often within minutes.
            </p>

            {/* Stats Row */}
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-5">
              {EMPLOYER_STATS.map((s) => (
                <div key={s.label} className="bg-[#fafafa] rounded-xl border border-gray-100 p-4">
                  <div className="text-2xl font-black text-gray-900">{s.value}</div>
                  <div className="text-xs text-gray-500 mt-0.5">{s.label}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Right: Post Job Form */}
          <div className="w-full lg:w-[460px] shrink-0 bg-white border border-gray-200 rounded-2xl p-7 mb-8 lg:-mb-6 relative z-10">
            <div className="mb-5">
              <h2 className="text-lg font-extrabold text-gray-900">Post an Urgent Job</h2>
              <p className="text-xs text-gray-500 mt-1">Fill in the details and get matched within minutes.</p>
            </div>
            <PostJobPanel />
          </div>
        </div>

        {/* Bottom wave */}
        <div className="absolute bottom-0 left-0 right-0 h-6 bg-[#fafafa]" style={{ borderTopLeftRadius: 9999, borderTopRightRadius: 9999 }} />
      </section>

      <HireFeatures />

      {/* Bottom CTA */}
      <section className="py-16 bg-emerald-500">
        <div className="max-w-7xl mx-auto px-4 md:px-8 text-center">
          <h2 className="text-2xl md:text-3xl font-extrabold text-white mb-3">
            Ready to Build Your Workforce?
          </h2>
          <p className="text-emerald-100 mb-7 max-w-md mx-auto text-base">
            Join 3,200+ employers already using Gig <span className="italic">n&apos;</span> Cash to hire faster and pay less in overhead.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <a
              href="#post-job"
              onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: "smooth" }); }}
              className="px-8 py-3.5 bg-white text-emerald-700 font-bold rounded-xl text-sm hover:bg-emerald-50 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-add-circle-line mr-2" />
              Post Your First Job Free
            </a>
            <a
              href="/pricing"
              className="px-8 py-3.5 bg-white/10 border border-white/20 text-white font-bold rounded-xl text-sm hover:bg-white/20 transition-colors cursor-pointer whitespace-nowrap"
            >
              View Employer Plans
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
